import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Footer, Loader} from '../../components';
import {redirectToTakePhotoDocument} from '../../ducks/Navigate';
import {
  updateDadosDocumentoImage,
  documentoFrenteAdicionar,
  documentoVersoAdicionar,
} from '../../ducks/Customer';
import {RouteKeys} from '../../constants';
import {StringService} from '../../services';

import './styles.scss';

class ConfirmationPhotoDocument extends Component {
  componentDidMount() {
    document.title = this.isVerso()
      ? StringService.formatTitle(RouteKeys.ConfirmationPhotoDocumentBack)
      : StringService.formatTitle(RouteKeys.ConfirmationPhotoDocument);

    let renderSrcImage = this.renderSrcImage();
    if (renderSrcImage == null)
      this.props.redirectToTakePhotoDocument(this.isVerso());
  }

  handleFinish = (event) => {
    event.preventDefault();

    const request = {
      chave: this.props.chave,
      imagem: this.renderSrcImage(),
    };

    if (this.isVerso()) this.props.documentoVersoAdicionar(request);
    else this.props.documentoFrenteAdicionar(request);
  };

  isVerso = () => this.props.verso;

  renderSrcImage = () =>
    this.isVerso() ? this.props.imagem.verso : this.props.imagem.frente;

  render() {
    return (
      <div className="div-confirm-your-photo-document">
        <div className="header">
          <p>Os dados do seu documento estão legíveis?</p>
        </div>
        <div className="content">
          <div className="info">
            <p>Se sim, clique em "Próximo"</p>
            <img
              className="img-src"
              src={this.renderSrcImage()}
              alt="Documento"
            />
            <p>Se não, por favor tire outra.</p>
          </div>
        </div>
        <Footer
          backHandle={() => {
            const prop = this.isVerso() ? 'verso' : 'frente';
            const value = null;
            this.props.updateDadosDocumentoImage({prop, value});
            this.props.redirectToTakePhotoDocument(this.isVerso());
          }}
          nextHandle={this.handleFinish}
          textBack="Tirar outra"
        />
        <Loader />
      </div>
    );
  }
}

const mapStateToProps = ({customer}) => {
  const {chave} = customer;
  const {imagem} = customer.dadosDocumento;
  return {chave, imagem};
};

export default connect(mapStateToProps, {
  redirectToTakePhotoDocument,
  updateDadosDocumentoImage,
  documentoFrenteAdicionar,
  documentoVersoAdicionar,
})(ConfirmationPhotoDocument);
